import { BenefitType } from "v2/infrastructure/Benefits/types/BenefitTypes";
import { Properties } from "v2/infrastructure/common/types/FunctionPropertiesType";
import Benefit from "v2/domain/benefits/entities/Benefit";

export default class CustomBenefit extends Benefit {
  type: BenefitType.CUSTOM;

  name: string;

  iconUrl: string;

  constructor({ name, iconUrl, ...benefitProps }: Properties<CustomBenefit>) {
    super(benefitProps);

    this.type = benefitProps.type;
    this.name = name;
    this.iconUrl = iconUrl;
  }
}
